import { createSlice } from "@reduxjs/toolkit";
import { IBeneficiary, IBneficiariesList, IPageInfo } from "../../types/index";
import { logout, setProduct } from "./authSlice";


interface DashboardState {
  beneficiariesList: Array<IBneficiariesList>;
  beneficiaries: {
    pageInfo: IPageInfo,
    beneficiaries: Array<IBeneficiary> | [],
    scheduleId?: string
  } | null
}

const initialState: DashboardState = {
  beneficiariesList: [],
  beneficiaries: null
}

export const beneficiariesSlice = createSlice({
  name: "Beneficiary",
  initialState,
  reducers: {
    addBeneficiariesList: (state, action) => {
      state.beneficiariesList = action.payload;
    },
    addBeneficiareies: (state, action) => {
      state.beneficiaries = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state = { ...initialState };
      return state;
    });
    builder.addCase(setProduct, (state) => {
      state = { ...initialState };
      return state;
    });
  }
})

export const {
  addBeneficiariesList,
  addBeneficiareies
} = beneficiariesSlice.actions;

export default beneficiariesSlice.reducer;
